'use strict'

export function sellerFlagEnabled (v) {
  if (v === false || v === 0 || v === '0' || v === 'false') return false
  return true
}

function readFlag (obj, camel, snake) {
  if (!obj) return true
  if (obj[camel] !== undefined && obj[camel] !== null) return sellerFlagEnabled(obj[camel])
  if (obj[snake] !== undefined && obj[snake] !== null) return sellerFlagEnabled(obj[snake])
  return true
}

function hasFlag (obj, camel, snake) {
  if (!obj) return false
  return (obj[camel] !== undefined && obj[camel] !== null) ||
    (obj[snake] !== undefined && obj[snake] !== null)
}

// Backend attributes are no longer a storefront switch (per-user Alert Settings preference), so only "Stop all alerts".
export function flagsFromSellerRow (row) {
  return {
    alertsEnabled: readFlag(row, 'alertsEnabled', 'alerts_enabled')
  }
}

export function mergeKillSwitchFlags (seller, body) {
  var next = Object.assign({}, seller || {})
  if (hasFlag(body, 'alertsEnabled', 'alerts_enabled')) {
    next.alertsEnabled = readFlag(body, 'alertsEnabled', 'alerts_enabled')
  } else if (next.alertsEnabled === undefined) {
    next.alertsEnabled = true
  }
  return next
}

export function patchBodyForStopToggle (field, stopChecked) {
  var body = {}
  body[field] = !stopChecked
  return body
}



// WEBPACK FOOTER //
// ./src/utils/sellerKillSwitches.js